import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '@services/auth.service';
import {NotificationsProvider} from '@providers/notifications/notifications.provider';
import {InstantNotificationsService} from '@services/instant-notifications.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-layout',
    providers: [
        InstantNotificationsService,
    ],
    templateUrl: 'app-layout.component.html'
})

export class AppLayoutComponent implements OnInit, OnDestroy {

    public notificationsCountLabel = '';

    private subs: Subscription[] = [];

    /**
     * Подключаем сервис мгновенных уведомлений, чтобы он инициализировался в приложении
     */
    constructor(
        public authService: AuthService,
        public notificationsProvider: NotificationsProvider,
        private instantNotificatonsService: InstantNotificationsService
    ) {
    }

    ngOnInit() {
        this.subs.push(
            this.notificationsProvider.countNew$.subscribe((count) => {
                if (count <= 0) {
                    this.notificationsCountLabel = '';
                    return;
                }

                this.notificationsCountLabel = count > 9 ? `9+` : count.toString();
            })
        );
    }

    logout() {
        this.authService.logout();
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}
